import list from './list'
import form from './form'
import domain from './domain'
import password from './password'
import plugins from './plugins'

export default {
  list,
  form,
  domain,
  password,
  plugins
}
